"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEosAccount = exports.getRefId = exports.updateAvatar = exports.updateUser = void 0;
var axios_1 = __importDefault(require("axios"));
var catchAxiosError_1 = __importDefault(require("../../util/catchAxiosError"));
var updateUser = function (payload) {
    var token = payload.token, params = payload.params, id = payload.id;
    return axios_1.default
        .post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/users/").concat(id), params, {
        headers: {
            Authorization: 'Bearer' + token
        }
    })
        .catch(catchAxiosError_1.default);
};
exports.updateUser = updateUser;
var updateAvatar = function (payload) {
    var file = payload.file, token = payload.token, user_id = payload.user_id;
    var formData = new FormData();
    formData.append('file', file);
    formData.append('action', 'bp_avatar_upload');
    return axios_1.default.post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/buddypress/v1/members/").concat(user_id, "/avatar"), formData, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'multipart/form-data'
        }
    }).catch(catchAxiosError_1.default);
};
exports.updateAvatar = updateAvatar;
var getRefId = function (payload) {
    var token = payload.token, userId = payload.userId;
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/user/ref-id"), {
        user_id: userId,
        token: token
    }).catch(catchAxiosError_1.default);
};
exports.getRefId = getRefId;
var setEosAccount = function (payload) {
    var userId = payload.userId, token = payload.token, terraAccount = payload.terraAccount;
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/user/update_terra"), {
        userId: userId,
        token: token,
        terraAccount: terraAccount
    });
};
exports.setEosAccount = setEosAccount;
